import axios from "./interceptors";
import { PORT_API_COURSES } from "../config/environment";

export const getSubjectsAndCourses = () => {
  return axios.get(`${PORT_API_COURSES}/api/subscriptions/student/courses/`);
};
